module.exports = __webpack_public_path__ + "h5/img/icon_zj_cur.776a65dc.png";